import classNames from "classnames";
import { ReactNode } from "react";

import { DataTable } from "@/components/DataTable";
import { FormatDate } from "@/components/Date";
import { SosEntityLink } from "@/components/SosEntityLink";
import { SosCustomFields } from "@/utils/sos/custom-fields";
import { withEstimateTrackingData } from "../withEstimateTrackingData";
import { estimateDetailsTableColumns } from "./estimate-details-table-columns";
import { processTableRow, TableLineItem } from "./estimate-details-table-data";
import { TableWrapper } from "@/components/TableWrapper";

export const EstimateDetails = withEstimateTrackingData(({ estimate, bomHierarchy }) => {
  const orderDetails: { label: string; value: ReactNode | undefined | null }[] = [
    { label: "Estimate #", value: <SosEntityLink type="estimate" id={estimate.id} label={estimate.number} /> },
    {
      label: "Evolved Opportunity #",
      value: SosCustomFields.getNumberValue(estimate, "evolvedOpportunityNumber") || "N/A",
    },
    { label: "Date", value: <FormatDate date={estimate.date} /> },
    {
      label: "Customer",
      value: <SosEntityLink type="customer" id={estimate.customer.id} label={estimate.customer.name} />,
    },
  ];

  const tableData = estimate.lines.map<TableLineItem>((line, index) => processTableRow(line, index, bomHierarchy));

  return (
    <>
      <div className="col-auto">
        <dl className="row">
          {orderDetails.map(({ label, value }, index, array) => (
            <div key={label} className="col-12 col-md-6 col-lg-4 col-xl-3">
              <dt>{label}</dt>
              <dd className={classNames({ "m-0": index === array.length - 1 })}>{value}</dd>
            </div>
          ))}
          {estimate.customerMessage && (
            <div className="col-12 col-lg-6">
              <dt>Customer Message</dt>
              <dd className="text-pre-wrap">{estimate.customerMessage}</dd>
            </div>
          )}
          {estimate.comment && (
            <div className="col-12 col-lg-6">
              <dt>Memo</dt>
              <dd className="text-pre-wrap">{estimate.comment}</dd>
            </div>
          )}
        </dl>
      </div>
      <TableWrapper className="col">
        <DataTable
          bordered
          hover
          columns={estimateDetailsTableColumns}
          data={tableData}
          initialState={{ sorting: [{ id: "lineNumber", desc: false }] }}
        />
      </TableWrapper>
    </>
  );
});
